import {
  AutomationOperation,
  CreateAutomationPayload,
  IntegrationConsumer,
  IntegrationProvider,
  IntegrationSource,
  SalesforceActions,
} from 'api/integrations';
import { toApiFormat } from 'utils/simple-search-filter/simple-search-filter';
import { PartialSalesforceAutomationLocalData } from '../../types';

export const serialiseAutomationPayload = (
  integrationId: number,
  automationDetails: PartialSalesforceAutomationLocalData,
): CreateAutomationPayload | undefined => {
  if (
    automationDetails.triggers?.type &&
    automationDetails.salesforceObject != null
  ) {
    return {
      automationName: automationDetails.automationName,
      description: automationDetails.description,
      integrationType: IntegrationProvider.SalesForce,
      object: automationDetails.salesforceObject.value as string,
      triggerCondition: {
        match: automationDetails.triggers.type,
        nativeFields: automationDetails?.triggers?.criteria.map(
          (criterion) => ({
            name: criterion.field.fieldId.toString(),
            ...toApiFormat(criterion),
          }),
        ),
      },
      matchingCondition: automationDetails?.matches
        ? {
            match: automationDetails?.matches?.type,
            nativeFields: automationDetails?.matches?.criteria.map((match) => ({
              name: match.field.fieldId.toString(),
              ...toApiFormat(match),
            })),
          }
        : undefined,
      actions: [
        {
          integrationType: IntegrationConsumer.Rocketlane,
          resourceType: SalesforceActions.Project,
          operation: AutomationOperation.Upsert,
          inputs: Object.keys(automationDetails?.rocketlaneFields ?? {}).reduce(
            (acc, eachField) =>
              eachField === 'teamMembers'
                ? {
                    ...acc,
                    [eachField]:
                      automationDetails?.rocketlaneFields?.[eachField],
                  }
                : {
                    ...acc,
                    [eachField]:
                      automationDetails?.rocketlaneFields?.[eachField]
                        ?.valueStr,
                  },
            {},
          ),
        },
      ],
      source: IntegrationSource.NativeIntegration,
      sourceId: integrationId,
      enabled: true,
    };
  }

  return undefined;
};
